<template>
  <v-row align="center" justify="center">
    <v-col :order-md="value.opposite ? 1 : 2">
      <v-img
        :aspect-ratio="aspectRatio"
        :sizes="imgResp.sizes"
        :src="imgResp.src"
        :srcset="imgResp.srcset"
        alt="Photo for story item"
        max-height="480"
      />
    </v-col>

    <v-col
      :order-md="value.opposite ? 2 : 1"
      cols="12"
      md="7"
      class="pb-12 pt-md-12"
    >
      <h3 v-if="value.title" class="text-h5 text-md-h4 mb-4">
        {{ value.title }}
      </h3>

      <ContentBlock
        :value="value.content"
        class="text-body-0 text-left"
        em-class="font-weight-black"
      />

      <v-btn
        v-if="value.cta && value.cta.action && value.cta.href"
        :href="value.cta.href"
        :target="hrefTarget(value.cta.href)"
        class="text-none ma-1 mt-6"
        color="secondary"
        exact
        rounded="pill"
        size="large"
      >
        {{ value.cta.action }}</v-btn
      >
    </v-col>
  </v-row>
</template>

<script setup>
import { toRef } from 'vue'
import { useImgResponsive } from '#root/lib/img'
import { hrefTarget } from '#root/lib/utils'

const props = defineProps({
  opposite: {
    default: false,
    type: Boolean
  },
  value: {
    required: true,
    type: Object
  }
})

const aspectRatio = 1
const imgResp = useImgResponsive(
  toRef(() => ({
    aspectRatio,
    image: props.value.image,
    sizes: {
      lg: '1600px'
    }
  }))
)
</script>
